import { render } from "./CustomersEdit.vue?vue&type=template&id=76023bec"
import script from "./CustomersEdit.vue?vue&type=script&lang=js"
export * from "./CustomersEdit.vue?vue&type=script&lang=js"
script.render = render

export default script